export const config = {
  reCaptcha_key: "6Le2X74aAAAAAPIr3r5J7JoAbSYT3bKF629c3fp1",
  appDownloadUrl: "https://zipmex.onelink.me/8NSq/15940e3a",
};
